import { type FunctionComponent, type PropsWithChildren } from 'react';
import { getLinkStyles } from '../../../helpers/link-style/link-style';
import { Link, type LinkProps } from './link.component';
import type { LinkStyleProps } from './link.types';

export type StyledLinkProps = PropsWithChildren<LinkStyleProps & LinkProps>;

/**
 * A Link that supports visual enhancements (color, underline etc.)
 */
export const StyledLink: FunctionComponent<StyledLinkProps> = ({ color = 'primary', className = '', underline, ...restProps }) => {
	const linkStyles = getLinkStyles(color);

	return <Link isStyledLink className={`${linkStyles} ${className}`.trim()} color={color} underline={underline} {...restProps} />;
};
